export default __webpack_public_path__ + "static/media/ACE.d66e5cd3.png";